import React from 'react';
import { Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-7 px-4 border-t-2 border-brand-accent/30" data-id="element-76">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-77">
        <div className="inline-block bg-brand-accent text-brand-dark font-black px-4 py-1.5 rounded-full mb-4 text-xs tracking-widest uppercase shadow-[0_0_15px_rgba(34,197,94,0.4)]" data-id="element-78">
          📘 KIT COMPLETO EDUCACIÓN FINANCIERA LISTA
        </div>

        <a href="mailto:kitonline27@gmail.com" className="inline-flex items-center gap-2 text-xs md:text-sm font-bold mb-4 text-gray-300 hover:text-brand-accent transition-colors" data-id="element-79">
          <Mail className="w-4 h-4 text-brand-accent" data-id="element-80" />
          <span data-id="element-81">
            ¿Tenés dudas? Escribinos a{' '}
            <span className="text-brand-accent" data-id="element-82">kitonline27@gmail.com</span>
          </span>
        </a>

        <div className="w-full pt-4 mt-2 border-t border-white/5 space-y-2 text-[10px] md:text-xs text-gray-500 font-bold uppercase tracking-wider" data-id="element-83">
          <p data-id="element-84">© 2026 Kit Completo Educación Financiera Lista™</p>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-85">
            <span className="hover:text-brand-accent cursor-pointer transition-colors" data-id="element-86">
              Términos
            </span>
            <span className="text-gray-700" data-id="element-87">·</span>
            <span className="hover:text-brand-accent cursor-pointer transition-colors" data-id="element-88">
              Privacidad
            </span>
            <span className="text-gray-700" data-id="element-89">·</span>
            <span className="hover:text-brand-accent cursor-pointer transition-colors" data-id="element-90">
              Soporte
            </span>
          </div>
        </div>
      </div>
    </footer>;
}